export default "__VITE_ASSET__Ct1pDVwj__"